module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAUCAYAAABvVQZ0AAABKklEQVQ4T92TPU7DQBCF33gdESNBSXIEWhQJwnIHoKahhJY0iDSIIotoTAstBTUcAgsUW7TcgIQyCCzhXQ9yEeTfiJCKbLkz783Op7eEiiMDdQHgCEAt1RIBuPRa3eMyGW16rsP1z32LRGPc4K2dnElfhSDU8yICwodWd1E+n5+OazGbYRTrG5J+7w5EO2mRibgpFqgDwx0Q2T81Zg1BrrHZFV80yAxivifpKw2CyBeM/jh4aqth/mUbj72GVaMrAnazGhiSgeIqbtPe/yOzVaeBJduZuOG7DvESFnCisObeyjqW7UIiMuYjHeL2rV8YOGfMkv3KuP2JWWJWxm0OmFVlK52PXzOrytZEs2k/d8ZsK1CvDDRnMUm0BAyo3VfbwsL1LIaJkY7jw2+Z5ZFTr2hy/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/duimmxi_icon.png
// module id = gpj0
// module chunks = 1